import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ItemInOrderOutputDto } from 'src/generated_client';

@Component({
  selector: 'app-shop-order-detail',
  templateUrl: './shop-order-detail.component.html',
  styleUrls: ['./shop-order-detail.component.css']
})

export class ShopOrderDetailComponent implements OnInit {

  Data: Elements = {
    items: [{}]
  };
  
  displayedColumns: string[] = ['articulo','cantidad','precio', 'extras'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Elements,
  ) {}

  ngOnInit(): void {
    this.Data = this.data;
    console.log(this.Data);
  }

  get Total() {
    return Number(this.Data.total);
  }

  get Delivery() {
    return Number(this.Data.delivery);
  }

  get Discount() {
    return Number(this.Data.discount);
  }
}

interface Elements {  
  items: Array<ItemInOrderOutputDto>;
  delivery?: number;
  discount?: number;
  discountItemValue?: number;
  total?: number;
  notes?: string;
}
